export default __webpack_public_path__ + "static/media/login-background.36ad73e4.jpg";